import { useTrackView } from '@seek/cmsu-analytics';
import { EMPLOYER_CONTACT_US_URL } from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Text, Card, ContentBlock, Stack, TextLink } from 'braid-design-system';
import { useEffect } from 'react';

import { URL_USER_VERIFICATION_COMPLETE } from 'src/constants/page-urls';
import { META_TITLE_REGISTRATION_COMPLETE } from 'src/constants/pageMetaData';
import { USER_CONFIRM_PAGE_VIEW } from 'src/constants/pageViewUniqueKeys';
import { useConfig } from 'src/hooks/context';
import { useHygraphRichText } from 'src/hooks/use-hygraph-rich-text';
import { USER_VERIFICATION_COMPLETE_CONTACT_US } from 'src/modules/ApiClient/cms/richTextConstants';
import CsPhoneNumber from 'src/views/shared/CsPhoneNumber/CsPhoneNumber';
import HygraphRichText from 'src/views/shared/Hygraph/HygraphRichText';
import PageHeading from 'src/views/shared/PageHeading/PageHeading';
import SeoMeta from 'src/views/shared/SeoMeta/SeoMeta';

import translations from './.vocab';

const UserVerificationCompletePage = () => {
  const { site, isAnz, absoluteEmployerUrlResolver, urlResolver } = useConfig();
  const { t } = useTranslations(translations);
  const userVerificationCompleteContactUsContent = useHygraphRichText(
    USER_VERIFICATION_COMPLETE_CONTACT_US,
  );

  const trackFunction = useTrackView(USER_CONFIRM_PAGE_VIEW);

  useEffect(() => {
    if (trackFunction) {
      trackFunction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTimeout(() => {
      window.location.assign('/oauth/login/');
    }, 3000);
  }, []);

  const fullUrl = absoluteEmployerUrlResolver(URL_USER_VERIFICATION_COMPLETE);

  const AnzContactDetails = () => (
    <>
      {t('ANZ Contact customer service message')} <CsPhoneNumber site={site} />
    </>
  );

  const NonAnzContactDetails = () => (
    <>
      {t('Contact customer service message', {
        Link: (children) => (
          <TextLink
            href={urlResolver({
              path: EMPLOYER_CONTACT_US_URL[site],
            })}
            target="_blank"
          >
            {children}
          </TextLink>
        ),
      })}
    </>
  );

  return (
    <>
      <SeoMeta
        title={META_TITLE_REGISTRATION_COMPLETE}
        description={''}
        url={fullUrl}
      />
      <ContentBlock>
        <PageHeading title={t('Email is confirmed title')} />

        <Card>
          <Stack space="medium">
            {userVerificationCompleteContactUsContent ? (
              <HygraphRichText
                textProps={{ component: 'p' }}
                richTextData={userVerificationCompleteContactUsContent}
              />
            ) : (
              <>
                <Text component="p">{t('Resume posting job ad message')}</Text>
                <Text component="p">
                  {isAnz ? <AnzContactDetails /> : <NonAnzContactDetails />}
                </Text>
              </>
            )}
          </Stack>
        </Card>
      </ContentBlock>
    </>
  );
};

export default UserVerificationCompletePage;
